import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";

import { MiscService } from "src/app/services/misc/misc.service";
import { AddressBookService } from "src/app/services/general/addressbook.service";
import { AlphaNumericValidation, MobileNumberValidation, TelephoneNumberValidation } from "src/app/models/validator";
import { AppCoreService } from "src/app/services/app-core.service";
import { Title } from "@angular/platform-browser";
import { Utilities } from "src/app/models/utilities";
import { NgxUiLoaderService } from "ngx-ui-loader";


@Component({
  selector: 'app-editaddressbook',
  templateUrl: './editaddressbook.component.html',
  styleUrls: ['./editaddressbook.component.scss']
})
export class EditAddressbookComponent implements OnInit, AfterViewInit {
  addressBookId: string;
  addressbookForm: FormGroup;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  isFormSubmitted: boolean;
  industryTypeList: any[] = [];
  locationDetails: any;
  firmList: any[] = [{ name: 'GOVT' }, { name: 'NON GOVT' }];
  useEnterKey: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private appCoreService: AppCoreService,
    private addressBookService: AddressBookService,
    private miscService: MiscService,
    private titleService: Title,
    private utilities: Utilities,
    private ngxLoaderService: NgxUiLoaderService,
  ) {
    titleService.setTitle('Addressbook');
  }

  ngOnInit(): void {
    const currentDate = this.utilities.FormatDateWithTime()?.dateString;
    this.addressbookForm = this.formBuilder.group({
      // txtCode: [null, Validators.compose([Validators.required, Validators.maxLength(6)])],
      txtName: [null, Validators.compose([Validators.required, Validators.maxLength(50)])],
      txtContactPerson: [null, Validators.compose([Validators.maxLength(50)])],
      txtEmailId: [null, Validators.email],
      // txtMobile: [null, MobileNumberValidation],
      // txtFax: [null, Validators.maxLength(20)],
      txtGST: [null, Validators.maxLength(20)],
      txtIEC: [null, Validators.maxLength(20)],
      ddlIndustryType: [],
      locationdetails: this.formBuilder.group({
        ddlCountry: [null, Validators.required],
        ddlState: [null, Validators.required],
        ddlCity: [null, Validators.required],
        txtPincode: [null],
        txtAddress1: [null, Validators.compose([Validators.required, Validators.maxLength(150)])],
        txtAddress2: [null, Validators.maxLength(150)],
        txtArea: [null, Validators.maxLength(30)],
        txtMobileNo: [null, Validators.compose([Validators.required, MobileNumberValidation])],
        txtTelephoneNo: [null, TelephoneNumberValidation],
      }),
    bankDetails: this.formBuilder.group({
           txtBankName: [null],
           txtAccountNo: [null, Validators.pattern(/^[a-zA-Z0-9]{1,20}$/)],
           txtAccountName: [null],
           txtIfscCode: [null, AlphaNumericValidation],
           txtMicr: [null, Validators.pattern(/^\d{9}$/)],
           txtBankAddress: [null],
           // txtBankAdCode: [null, Validators.compose([Validators.maxLength(30)])],
           // nfeiCheck: [null],
           // ddlFirm: [null]
         }),
      lutdetails: this.formBuilder.group({
        txtLutBondNo: [null, Validators.compose([Validators.maxLength(30)])],
        lutIssueDate: [null],
        lutTillDate: [null]
      }),
      status: ['true']
    });

    this.isFormSubmitted = false;
    this.addressBookId = this.route.snapshot.params['id'];
    this.checkPermission();
    if (this.permConfig.isEditAllowed) {
      this.bindIndustries();
      this.bindAddressBookById();
    }
  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.addressbookForm) : null;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;

    const permission = userData.config.filter(x => x.categoryname === 'AddressBook');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  bindIndustries() {
    try {
      this.miscService.GetAllIndustries().subscribe((res) => {
        if (res && res.success) {
          this.industryTypeList = res.data;
        }
      });

    } catch (e) {
      console.error(e);
    }
  }

  bindAddressBookById() {
    try {
      this.addressBookService.GetById(this.addressBookId).subscribe((res) => {
        if (res && res.success) {
          let resData = res.data[0];
          this.addressbookForm.patchValue({
            txtName: resData.name,
            txtContactPerson: resData.contactperson,
            txtEmailId: resData.emailid,
            // txtMobile: resData.mobile,
            // txtFax: resData.fax,
            txtGST: resData.gstno,
            txtIEC: resData.iecno,
            ddlIndustryType: resData.industrytypeid,
            status: resData.status,

          });
          // bind location details for child component
          this.addressbookForm.get('bankDetails').patchValue({
            txtBankName: resData?.additionaldetails?.bankname,
            txtAccountNo: resData?.additionaldetails?.bankaccountno,
            txtAccountName: resData?.additionaldetails?.bankaccountname,
            txtBankAddress: resData?.additionaldetails?.bankaddress,
            txtIfscCode: resData?.additionaldetails?.bankifsc,
            txtMicr: resData?.additionaldetails?.micr,
            // txtBankAdCode: data?.additionaldetails?.bankadcode,
            // ddlFirm: data?.additionaldetails?.firm,
            // nfeiCheck: data?.additionaldetails?.nfei,
          });

          this.addressbookForm.get('lutdetails').patchValue({
            txtLutBondNo: resData?.additionaldetails?.lutbondno,
            lutIssueDate: resData?.additionaldetails?.lutissuedate,
            lutTillDate: resData?.additionaldetails?.luttilldate
          });

          this.locationDetails = resData.location;
        }
      });

    } catch (e) {
      console.error(e);
    }
  }

  updatesAddressBook() {
    if (!this.permConfig.isEditAllowed) {
      this.warningDialog('No access to Edit.');
      return;
    }

    if (this.addressbookForm.invalid) {
      return;
    }

    if (this.addressbookForm.get('lutdetails.lutIssueDate')?.value > this.addressbookForm.get('lutdetails.lutTillDate')?.value) {
      this.appCoreService.showMessage('LUT Issue Date exceed LUT Till Date.', 'Warning', 'warning');
      return;
    }

    this.isFormSubmitted = true;
    let locationArea = this.addressbookForm.get('locationdetails').get('txtArea').value;
    locationArea = (typeof locationArea === 'string') ? locationArea : locationArea?.area;
    let locationPincode = this.addressbookForm.get('locationdetails').get('txtPincode').value;
    locationPincode = (typeof locationPincode === 'string') ? locationPincode : locationPincode?.pincode;

    const requestObj = {
      id: Number(this.addressBookId),
      name: this.addressbookForm.get('txtName').value,
      contactperson: this.addressbookForm.get('txtContactPerson').value,
      emailid: this.addressbookForm.get('txtEmailId').value,
      // mobile: this.addressbookForm.get('txtMobile').value,
      // fax: this.addressbookForm.get('txtFax').value,
      gstno: this.addressbookForm.get('txtGST').value,
      iecno: this.addressbookForm.get('txtIEC').value,
      industrytype: this.addressbookForm.get('ddlIndustryType').value,
      location: {
        country: this.addressbookForm.get('locationdetails').get('ddlCountry').value,
        state: this.addressbookForm.get('locationdetails').get('ddlState').value,
        city: this.addressbookForm.get('locationdetails').get('ddlCity').value,
        pincode: locationPincode,
        address1: this.addressbookForm.get('locationdetails').get('txtAddress1').value,
        address2: this.addressbookForm.get('locationdetails').get('txtAddress2').value,
        area: locationArea,
        mobileno: this.addressbookForm.get('locationdetails').get('txtMobileNo').value,
        tel: this.addressbookForm.get('locationdetails').get('txtTelephoneNo').value
      },
      additionaldetails: {
        bankname: this.addressbookForm.get('bankDetails.txtBankName')?.value,
        bankaccountno: this.addressbookForm.get('bankDetails.txtAccountNo')?.value,
        bankadcode: this.addressbookForm.get('bankDetails.txtBankAdCode')?.value,
        bankaccountname: this.addressbookForm.get('bankDetails.txtAccountName')?.value,
        bankaddress: this.addressbookForm.get('bankDetails.txtBankAddress')?.value,
        bankifsc: this.addressbookForm.get('bankDetails.txtIfscCode')?.value,
        micr: this.addressbookForm.get('bankDetails.txtMicr')?.value,
        firm: this.addressbookForm.get('bankDetails.ddlFirm')?.value,
        nfei: this.addressbookForm.get('bankDetails.nfeiCheck')?.value,

        lutbondno: this.addressbookForm.get('lutdetails.txtLutBondNo')?.value,
        lutissuedate: this.addressbookForm.get('lutdetails.lutIssueDate')?.value,
        luttilldate: this.addressbookForm.get('lutdetails.lutTillDate')?.value
      },
      isactive: this.addressbookForm.get('status').value,
      generatedby: this.appCoreService.GetUserData().accessType,
      generatedfromid: this.appCoreService.GetUserData().selectedServiceCenter,
      customerid: this.appCoreService.GetUserData().metaInfo.customerid
    }
    this.ngxLoaderService.start();
    this.addressBookService.Update(requestObj).subscribe((res) => {
      try {
        if (res && res?.success) {
          this.ngxLoaderService.stop();
          // this.companyId = parseInt(res.data[0].id);
          this.openConfirmationDialog("Entry updated successfully");
          this.resetForm();
        } else if (res && !res?.success) {
          this.ngxLoaderService.stop();
          res?.error?.data?.err_msg? this.appCoreService.showMessage(res.error.data.err_msg, '', 'error'): null;
        }
      }
      catch (err) {
        this.ngxLoaderService.stop();
        console.error(err);
      }
    });
  }

  resetForm(): void {
    this.addressbookForm.reset();
    this.isFormSubmitted = false;
  }

  async openConfirmationDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      title: 'Success!',
      text: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (result.isConfirmed) {
      this.router.navigate(['/setup/general/addressbook']);
    }

  }


  warningDialog(msg: any) {
    Swal.fire({
      title: 'Warning!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
  }
}
